/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { searchPersonalSpaceStationsGnvCustom$Any } from '../fn/personal-space/search-personal-space-stations-gnv-custom-any';
import { SearchPersonalSpaceStationsGnvCustom$Any$Params } from '../fn/personal-space/search-personal-space-stations-gnv-custom-any';
import { searchPersonalSpaceStationsGnvCustom$Json } from '../fn/personal-space/search-personal-space-stations-gnv-custom-json';
import { SearchPersonalSpaceStationsGnvCustom$Json$Params } from '../fn/personal-space/search-personal-space-stations-gnv-custom-json';
import { StationGnvPagedList } from '../models/station-gnv-paged-list';


/**
 * All about the user personal space
 */
@Injectable({ providedIn: 'root' })
export class PersonalSpaceService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchPersonalSpaceStationsGnvCustom()` */
  static readonly SearchPersonalSpaceStationsGnvCustomPath = '/custom/personalspace/stations/search';

  /**
   * Search my stations gnv.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchPersonalSpaceStationsGnvCustom$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPersonalSpaceStationsGnvCustom$Json$Response(params?: SearchPersonalSpaceStationsGnvCustom$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvPagedList>> {
    return searchPersonalSpaceStationsGnvCustom$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my stations gnv.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchPersonalSpaceStationsGnvCustom$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPersonalSpaceStationsGnvCustom$Json(params?: SearchPersonalSpaceStationsGnvCustom$Json$Params, context?: HttpContext): Observable<StationGnvPagedList> {
    return this.searchPersonalSpaceStationsGnvCustom$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationGnvPagedList>): StationGnvPagedList => r.body)
    );
  }

  /**
   * Search my stations gnv.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchPersonalSpaceStationsGnvCustom$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchPersonalSpaceStationsGnvCustom$Any$Response(params?: SearchPersonalSpaceStationsGnvCustom$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvPagedList>> {
    return searchPersonalSpaceStationsGnvCustom$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my stations gnv.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchPersonalSpaceStationsGnvCustom$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchPersonalSpaceStationsGnvCustom$Any(params?: SearchPersonalSpaceStationsGnvCustom$Any$Params, context?: HttpContext): Observable<StationGnvPagedList> {
    return this.searchPersonalSpaceStationsGnvCustom$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationGnvPagedList>): StationGnvPagedList => r.body)
    );
  }

}
